import React from "react";
import { WithStyles, withStyles } from "@material-ui/core/styles";
import Switch, { SwitchProps } from "@material-ui/core/Switch";
import { iosSwitchStyles } from "./styles";

interface IOSSwitchProps
  extends Omit<SwitchProps, "classes">,
    WithStyles<typeof iosSwitchStyles> {}

const IOSSwitch: React.FC<IOSSwitchProps> = ({ classes, ...props }) => (
  <Switch
    focusVisibleClassName={classes.focusVisible}
    disableRipple
    classes={{
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked,
    }}
    {...props}
  />
);

export default withStyles(iosSwitchStyles)(IOSSwitch);
